import React from 'react';
import { groupBy } from 'lodash';
import PropTypes from 'prop-types';

import { getIcon } from './iconProvider';
import {
  CARPET_OCCUPATION_ID, GARAGE_OCCUPATION_ID, LOCKSMITH_OCCUPATION_ID, SERVICE
} from '../../utils/constants';

import styles from './index.module.scss';

const Services = ({ services, occupationId }) => {
  const validSkillset = services.filter((el) => el.job_sub_category_name);
  let byCategory = groupBy(validSkillset, (el) => el.job_sub_category_name);

  if (occupationId === GARAGE_OCCUPATION_ID) {
    byCategory = {
      Garage: [{
        job_service_name: 'Cable repair / installation',
        job_service_id: SERVICE.GARAGE.CABLE_REPAIR
      }, {
        job_service_name: 'Spring repair / installation',
        job_service_id: SERVICE.GARAGE.SPRING_REPAIR
      }, {
        job_service_name: 'Garage door installation',
        job_service_id: SERVICE.GARAGE.DOOR_INSTALLATION
      }, {
        job_service_name: 'Garage opener repair / installation',
        job_service_id: SERVICE.GARAGE.OPENER
      }]
    };
  }

  if (occupationId === CARPET_OCCUPATION_ID) {
    byCategory = {
      Carpet: [{
        job_service_name: 'Regular cleaning',
        job_service_id: SERVICE.CARPET.CLEANING
      }, {
        job_service_name: 'Deep cleaning',
        job_service_id: SERVICE.CARPET.DEEP_CLEANING
      }, {
        job_service_name: 'Odor removal',
        job_service_id: SERVICE.CARPET.ODOR_REMOVAL
      }, {
        job_service_name: 'Carpet stains removal',
        job_service_id: SERVICE.CARPET.STAINS_REMOVAL
      }]
    };
  }

  if (!services) {
    return <></>;
  }
  return (
    <div className={styles.services}>
      {Object.keys(byCategory).map((cat) => (
        <div key={cat}>
          {occupationId === LOCKSMITH_OCCUPATION_ID
          && <p className={styles.category}>{cat}</p>}
          <div className={styles.row}>
            {byCategory[cat].map((service) => {
              const id = service.job_service_id;
              return (
                <div key={service.job_service_id} className={styles.wrapper}>
                  <div className={styles.icon}>
                    {getIcon(id)}
                  </div>
                  <div className={styles.name}><span>{service.job_service_name.replace('/', ' /')}</span></div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

Services.propTypes = {
  services: PropTypes.array,
  occupationId: PropTypes.number,
};

export default Services;
